module.exports = __webpack_public_path__ + "static/media/story-banner.2005fc0f.svg";